import React from 'react';
import { verificationChecklist } from '../data/checklist';
export function VerificationChecklist() {
  return <section aria-label="Verification checklist" className="bg-ink-2" data-id="element-325" data-mp="hht6n96oy9gn">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "22px",
      paddingBottom: "27px"
    }} data-id="element-326" data-mp="mi74jyekw30y">
        <p className="text-center text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-327" data-mp="rhjzz7jimif5">
          Before you send or use an AI-generated document
        </p>
        <h2 className="mt-2 text-center font-display text-3xl font-bold uppercase text-fog sm:text-4xl" data-id="element-328" data-mp="3pwjnaqlq285n">
          A simple professional verification checklist
        </h2>
        <ol className="relative mt-9 space-y-6 border-l border-line pl-8" data-id="element-329" data-mp="3pv3rg3kp9sx">
          {verificationChecklist.map((item, i) => <li key={item.title} className="relative" data-id="element-330" data-mp="8k929rdj7x1t" data-mpi={i}>
              <span className="absolute -left-[45px] flex h-7 w-7 items-center justify-center rounded-full border border-gold bg-ink font-display text-sm font-bold text-gold" data-id="element-331" data-mp="378y3f5e9zlni">
                {i + 1}
              </span>
              <p className="font-bold text-fog" data-id="element-332" data-mp="lqdpm05rcyez">{item.title}</p>
              <p className="mt-1 text-sm leading-relaxed text-fog/65" data-id="element-333" data-mp="gs2dtjvwkdu4">{item.desc}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}